const store = {
  namespaced: true,
  state: {
    sched: [],
    calendar_sched: []
  },
  getters: {},
  mutations: {
    // @ts-ignore
    get (state, {events}) {
      state.sched = events
      state.calendar_sched = events
    },
    // @ts-ignore
    calendarGet (state, {events}) {
      state.calendar_sched = events
    }
  },
  actions: {
    // @ts-ignore
    async get (context, data) {
      const resp = await context.dispatch('apiRequest', {
        url: '/cproc/stud/calendar/events',
        data,
        flag: 'silent'
      }, {root: true})
      context.commit('get', resp);
    },
    // @ts-ignore
    async calendarGet (context, data) {
      const resp = await context.dispatch('apiRequest', {
        url: '/cproc/stud/calendar/events',
        data,
        flag: 'silent'
      }, {root: true})
      context.commit('calendarGet', resp);
    }
  }
}

export default store